import { IDictionary } from '../../extViewmodels';
import { useClientGetSurveyByToken, useClientGetSurveyLogoByToken } from '../../queries';
import { ISurvey } from './Api';

export function useSurvey<TSurvey extends ISurvey = ISurvey>({
	accessToken,
	options,
}: { accessToken?: string; options?: IDictionary<string> }) {
	const hasAccessToken = accessToken && accessToken.toLocaleLowerCase() !== 'unavailable';
	const surveyQuery = useClientGetSurveyByToken<TSurvey>({
		accessToken,
		enabled: hasAccessToken,
		options,
	});
	const surveyLogo = useClientGetSurveyLogoByToken({
		accessToken,
		enabled: hasAccessToken,
		refetchOnWindowFocus: false,
	});

	const nowDate = new Date();
	const isUnavailable =
		accessToken?.toLocaleLowerCase() === 'unavailable' ||
		surveyQuery.data?.archivedDate ||
		(surveyQuery.data?.startDate ? new Date(surveyQuery.data?.startDate) > nowDate : false) ||
		(surveyQuery.data?.expirationDate ? new Date(surveyQuery.data?.expirationDate) < nowDate : false);

	return { hasAccessToken, isUnavailable, surveyQuery, surveyLogo };
}
